import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMetricsSpread = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M38.85 9.151 24 3 9.151 9.151 3.001 24l6.15 14.849L24 45l14.849-6.15L45 24zM24 31.633c-6.944 0-13.49-2.836-17.725-7.633C10.51 19.203 17.056 16.368 24 16.368S37.49 19.203 41.726 24C37.49 28.797 30.944 31.633 24 31.633" }), /* @__PURE__ */ _jsx("circle", {
		cx: 24,
		cy: 24,
		r: 6.559
	})] }) })
});
export default SvgMetricsSpread;
